import { FC } from 'react';

import { Loader } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { BrandBackground } from 'APP/components/BrandBackground/BrandBackground';
import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';

import styles from './CallPreviewLoader.styles.m.css';

interface ICallPreviewLoaderProps {
  isDarkMode: boolean;
}

// TODO: layout рассмотреть в будущем использование AuthorizationLayout
export const CallPreviewLoader: FC<ICallPreviewLoaderProps> = ({ isDarkMode }) => {
  const { mainBackgroundLight, mainBackgroundDark } = PROJECT_CONFIG.imageAssets;
  return (
    <>
      <BrandBackground
        isDarkMode={isDarkMode}
        backgroundSrc={{
          light: getMascotImageSrc(mainBackgroundLight),
          dark: getMascotImageSrc(mainBackgroundDark),
        }}
      />
      <div className={styles.container}>
        <div className={styles.logo}>
          <ImageTheme
            lightImageName={PROJECT_CONFIG.imageAssets.mainLogoLight}
            darkImageName={PROJECT_CONFIG.imageAssets.mainLogoDark}
          />
        </div>
        <div className={styles.loader}>
          <Loader
            color="base-80"
            size="medium"
          />
        </div>
      </div>
    </>
  );
};
